module.exports = __webpack_public_path__ + "img/kids-3.9deec241.jpg";